import { callApi } from 'loankeeper-common/api'

// export const printReport = (params, body = {}) =>
//   callApi('printreport', {
//     method: 'post',
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//     params,
//     body,
//   })

export const printCRA = (params) =>
  callApi('sda_cra', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

export const printLoanCalculator = (params) =>
  callApi('loan_calculator', {
    params: {
      action: 'printloandemoschedule',
      ...params,
    },
  })

export const printClient = (params) =>
  callApi('client_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })
